import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TagType, CreateContractType, UpdateContractType } from 'Pages/partner'
import { RequestParams, ResponseCatalog } from 'Models'

type ContractsState = {
	reload: boolean
	contracts: any
	tags: ResponseCatalog<TagType>
	tagsRequestParams: RequestParams
}

const initialState: ContractsState = {
	reload: false,
	contracts: null,
	tags: new ResponseCatalog<TagType>(),
	tagsRequestParams: new RequestParams(),
}

export namespace ContractsNS {
	export type GetTags = PayloadAction<{
		params: RequestParams
		clear?: boolean
	}>
	export type SetTags = PayloadAction<ResponseCatalog<TagType>>
	export type SetTagsRequestParams = PayloadAction<RequestParams>
	export type CreateOne = PayloadAction<{
		partner_id: string
		document_type: string
		data: CreateContractType
	}>
	export type UpdateOne = PayloadAction<{
		partner_id: string
		id: string
		data: UpdateContractType
	}>
	export type DeleteOne = PayloadAction<{
		partner_id: string
		id: string
	}>
	export type SetIsLoading = PayloadAction<boolean>
	export type GetContacts = PayloadAction<{
		partner_id: string
	}>
}

export const contractsSlice = createSlice({
	name: 'contracts',
	initialState,
	reducers: {
		getTags: (state, action: ContractsNS.GetTags) => {},
		setTags: (state, action: ContractsNS.SetTags) => {
			state.reload = state?.reload ?? false
			state.tags = action.payload
		},
		setTagsRequestParams: (state, action: ContractsNS.SetTagsRequestParams) => {
			state.tagsRequestParams = action.payload
		},

		setIsLoading: (state, action: ContractsNS.SetIsLoading) => {
			state.reload = action.payload
		},
		clearAll: (state) => {
			state.tags = new ResponseCatalog<TagType>()
			state.tagsRequestParams = new RequestParams()
		},
		createOne: (state, action: ContractsNS.CreateOne) => {},
		updateOne: (state, action: ContractsNS.UpdateOne) => {},
		deleteOne: (state, action: ContractsNS.DeleteOne) => {},
		getContacts: (state) => {},
	},
})
